import { EmptyVariableSet, EmptyDataNode } from '../../variables/interpolation/defaults.js';
import { sceneInterpolator } from '../../variables/interpolation/sceneInterpolator.js';
import { lookupVariable } from '../../variables/lookupVariable.js';
import { getClosest } from './utils.js';
import { SceneDataLayers } from '../../querying/SceneDataLayers.js';

function getVariables(sceneObject) {
  var _a;
  return (_a = getClosest(sceneObject, (s) => s.state.$variables)) != null ? _a : EmptyVariableSet;
}
function getData(sceneObject) {
  var _a;
  return (_a = getClosest(sceneObject, (s) => s.state.$data)) != null ? _a : EmptyDataNode;
}
function isSceneLayout(s) {
  return "isDraggable" in s;
}
function getLayout(scene) {
  const parent = getClosest(scene, (s) => isSceneLayout(s) ? s : void 0);
  if (parent) {
    return parent;
  }
  return null;
}
function interpolate(sceneObject, value, scopedVars, format) {
  if (value === "" || value == null) {
    return "";
  }
  return sceneInterpolator(sceneObject, value, scopedVars, format);
}
function hasVariableDependencyInLoadingState(sceneObject) {
  if (!sceneObject.variableDependency) {
    return false;
  }
  for (const name of sceneObject.variableDependency.getNames()) {
    const variable = lookupVariable(name, sceneObject);
    if (!variable) {
      continue;
    }
    const set = variable.parent;
    if (set.isVariableLoadingOrWaitingToUpdate(variable)) {
      return true;
    }
  }
  return false;
}
function findObjectInternal(scene, check, alreadySearchedChild, shouldSearchUp) {
  if (check(scene)) {
    return scene;
  }
  let found = null;
  scene.forEachChild((child) => {
    if (child === alreadySearchedChild) {
      return;
    }
    let maybe = findObjectInternal(child, check);
    if (maybe) {
      found = maybe;
    }
  });
  if (found) {
    return found;
  }
  if (shouldSearchUp && scene.parent) {
    return findObjectInternal(scene.parent, check, scene, true);
  }
  return null;
}
function findObject(scene, check) {
  return findObjectInternal(scene, check, void 0, true);
}
function getDataLayers(sceneObject, localOnly = false) {
  let parent = sceneObject;
  let collected = [];
  let source;
  while (parent) {
    if (parent.state.$data && !(parent.state.$data instanceof SceneDataLayers)) {
      if (parent.state.$data.state.$data instanceof SceneDataLayers) {
        source = parent.state.$data.state.$data;
      }
    }
    if (parent.state.$data && parent.state.$data instanceof SceneDataLayers) {
      source = parent.state.$data;
    }
    if (source) {
      collected = collected.concat(source.state.layers);
      if (localOnly) {
        break;
      }
    }
    parent = parent.parent;
  }
  return collected;
}
function getAncestor(sceneObject, ancestorType) {
  let parent = sceneObject;
  while (parent) {
    if (parent instanceof ancestorType) {
      return parent;
    }
    parent = parent.parent;
  }
  throw new Error("Unable to find parent of type " + ancestorType.name);
}

export { findObject, getAncestor, getData, getDataLayers, getLayout, getVariables, hasVariableDependencyInLoadingState, interpolate };
//# sourceMappingURL=sceneGraph.js.map
